import { cn } from '@/shared/utils/cn';
import type { StoreFeatureItem } from '../data/storeFeatureSections.data';
import { StoreFeatureIcon } from './StoreFeatureIcon';

type StoreFeatureCardProps = {
  item: StoreFeatureItem;
};

function StoreFeatureTitle({ titleLines }: { titleLines: string[] }) {
  return (
    <>
      <span className="md:hidden">{titleLines.join(' ')}</span>
      <span className="hidden md:inline">
        {titleLines.map((line, index) => (
          <span key={line}>
            {index > 0 ? <br /> : null}
            {line}
          </span>
        ))}
      </span>
    </>
  );
}

function StoreFeatureDescription({ descriptionLines }: { descriptionLines: string[] }) {
  return (
    <>
      <span className="md:hidden">{descriptionLines.join(' ')}</span>
      <span className="hidden md:inline">
        {descriptionLines.map((line, index) => (
          <span key={line}>
            {index > 0 ? <br /> : null}
            {line}
          </span>
        ))}
      </span>
    </>
  );
}

export function StoreFeatureCard({ item }: StoreFeatureCardProps) {
  return (
    <article
      className={cn(
        'overflow-hidden bg-white shadow-[0_1px_8px_0_rgba(161,161,161,0.5)]',
        'flex items-center gap-4 px-4 py-5',
        'md:block md:px-6 md:py-0 md:text-center md:shadow-[0_10px_35px_0_rgba(0,0,0,0.1)]',
        'md:min-h-[310px]'
      )}
    >
      <div className="flex shrink-0 items-center justify-center md:mx-auto md:mt-11 md:mb-2.5">
        <StoreFeatureIcon
          iconId={item.id}
          className="scale-[0.72] origin-left md:scale-100 md:origin-center"
        />
      </div>

      <div className="min-w-0 flex-1 md:flex-none">
        <h3 className="text-base font-medium leading-snug text-[#35669f] md:font-serif md:text-xl md:leading-[26px]">
          <StoreFeatureTitle titleLines={item.titleLines} />
        </h3>
        <p className="mt-1 text-sm leading-relaxed text-[#4a4a4a] md:mt-3 md:px-8 md:text-[15px] md:leading-[21px]">
          <StoreFeatureDescription descriptionLines={item.descriptionLines} />
        </p>
      </div>
    </article>
  );
}
